import React, { useEffect, useState } from 'react';
// import PropTypes from 'prop-types';

const ButtonFor3Pl = ({ text, textColor = "se-text-black", onClick = () => { }, status }) => {

    const [backgroundColor, setBackgroundColor] = useState('#EFC41A');

    useEffect(() => {
        switch (status) {
            case 'NEW':
                setBackgroundColor('#EFC41A');
                break;
            case 'PICKED_UP':
                setBackgroundColor('#EFC41A');
                break;
            case 'OUT_FOR_DELIVERY':
                setBackgroundColor('#EFC41A');
                break;
            case 'RESCHEDULE':
                setBackgroundColor('#EFC41A');
                break;
            case 'DELIVERED':
                setBackgroundColor('#6DC2FF');
                break;
            case 'PARTIAL_DELIVERED':
                setBackgroundColor('#6DC2FF');
                break;
            case 'CANCELLED':
                setBackgroundColor('#FF9170');
                break;
            default:
                setBackgroundColor('#EFC41A');
        }
    }, [status])


    return (
        <div className='se-ml-auto se-mr-auto se-w-[95%]'>
            <button
                className={`${textColor} se-w-full se-px-4 se-py-2 se-rounded`}
                onClick={onClick}
                style={{ backgroundColor }}
            >
                <b>{text}</b>
            </button>
        </div>);
};

// ButtonFor3Pl.propTypes = {
//     text: PropTypes.string.isRequired,
//     textColor: PropTypes.string.isRequired,
//     onClick: PropTypes.func.isRequired,
//     status: PropTypes.string,
// };

export default ButtonFor3Pl;